import React, { useState} from 'react';
import isMobile from 'common/helpers/isMobile';
import classNames from 'classnames';

function Languages({ currentLanguage, languages, changeLanguage, productName, skipAll = false }) {

  const handleClickLanguage = (id, languageName) => e => {
    e.preventDefault;
    changeLanguage(id);

    window.dataLayer && window.dataLayer.push({
      event: 'Session_language',
      'selected_language': languageName,
      'name': productName,
      'pgURI': window.location.pathname
    });
    return false;
  };

  return (
    <div className="product-reservation__language">
      <div className="product-reservation__language-scroll" >
        { !skipAll && (
          <span
            className={classNames(`product-reservation__language-item`, {
              "is-active": currentLanguage == 0,
            })}
            href="#"
            onClick={handleClickLanguage(0, 'All')}
          >
            All
          </span>
        ) }
        {languages.map((item) => (
          <span
            className={classNames(`product-reservation__language-item`, {
              "is-active": item.id == currentLanguage,
            })}
            key={item.id}
            href="#"
            onClick={handleClickLanguage(item.id, item.original_name)}
          >
            {item.name}
          </span>
        ))}
      </div>
    </div>
  );
}

export default  Languages;
